import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { ISortSetting } from '../../../types';

import { ITableColumnSettings, RowClass } from './table-types';

export function formatDate(value: any, dataFilter: string): any {
    let convertedValue = value;

    try {
        const valueToConvert = value instanceof Date
            ? value
            : new Date(value);

        convertedValue = new DatePipe('en-US').transform(valueToConvert, dataFilter);
    } catch (e) { }

    return convertedValue;
}

export function getColumns(columnSettings: ITableColumnSettings[], sortColumns: boolean): ITableColumnSettings[]  {
    const visibleColumns = columnSettings.filter(column => !column.hasOwnProperty('isVisible') || column.isVisible === null || column.isVisible);

    if (sortColumns && visibleColumns.find(column => column.columnOrder !== null)) {
        visibleColumns.sort((a, b) => {
            if (a.columnOrder !== null) {
                return 1;
            }

            if (b.columnOrder !== null) {
                return -1;
            }

            return a.columnOrder - b.columnOrder;
        });
    }

    return visibleColumns;
}

export function getRowClass(dataItem: any, rowIndex: number): string {
    let rowClass = '';

    if (dataItem.rowClass && rowIndex % 2 === 0) {
        rowClass = `${dataItem.rowClass}-${RowClass.RowEven}`;
    } else if (dataItem.rowClass) {
        rowClass = dataItem.rowClass;
    } else if (rowIndex % 2 === 0) {
        rowClass = RowClass.RowEven;
    }

    return rowClass;
}

export function getSortOrder(propertyName: string, sortSettings: ISortSetting[]): number {
    return sortSettings.findIndex(setting => setting.field === propertyName) + 1;
}

export function isPropertySortDescending(propertyName: string, sortSettings: ISortSetting[]): boolean {
    return sortSettings.find(setting => setting.field === propertyName).descending;
}

export function isPropertySorted(propertyName: string, sortSettings: ISortSetting[]): boolean {
    return sortSettings.find(setting => setting.field === propertyName) != null;
}

export function isRowSelected(id: number, selectedRowIds: number[]): boolean {
    return selectedRowIds.indexOf(id) > -1;
}

@Pipe({ name: 'mcFormatDate' })
export class TableFormatDate implements PipeTransform {
    transform(value: any, dataFilter: string): any {
        return formatDate(value, dataFilter);
    }
}

@Pipe({ name: 'mcGetColumns' })
export class TableGetColumnsPipe implements PipeTransform {
    transform(columnSettings: ITableColumnSettings[], sortColumns: boolean = false): ITableColumnSettings[] {
        return getColumns(columnSettings, sortColumns);
    }
}

@Pipe({ name: 'mcGetRowClass' })
export class TableGetRowClassPipe implements PipeTransform {
    transform(dataItem: any, rowIndex: number): string {
        return getRowClass(dataItem, rowIndex);
    }
}

@Pipe({ name: 'mcGetSortOrder' })
export class TableGetSortOrderPipe implements PipeTransform {
    transform(propertyName: string, sortSettings: ISortSetting[], _updateTime: Date): number {
        return getSortOrder(propertyName, sortSettings);
    }
}

@Pipe({ name: 'mcIsPropertySortDescending' })
export class TableIsPropertySortDescendingPipe implements PipeTransform {
    transform(propertyName: string, sortSettings: ISortSetting[], _updateTime: Date): boolean {
        return isPropertySortDescending(propertyName, sortSettings);
    }
}

@Pipe({ name: 'mcIsPropertySorted' })
export class TableIsPropertySortedPipe implements PipeTransform {
    transform(propertyName: string, sortSettings: ISortSetting[], _updateTime: Date): boolean {
        return isPropertySorted(propertyName, sortSettings);
    }
}

@Pipe({ name: 'mcIsRowSelected' })
export class TableIsRowSelectedPipe implements PipeTransform {
    transform(id: number, selectedRowIds: number[], _updateTime: Date): boolean {
        return isRowSelected(id, selectedRowIds);
    }
}
